import React, { useState, useMemo } from "react"
import PropTypes from "prop-types"
import { formatCurrency, formatNumber } from "../helpers"

const cellHead = {
  padding: "10px 12px", fontSize: 11, fontWeight: 600,
  color: "#475569", textTransform: "uppercase", letterSpacing: 0.4,
  borderBottom: "1px solid #e2e8f0", background: "#f1f5f9",
  position: "sticky", top: 0, zIndex: 1,
}

const LineasTab = ({ data }) => {
  const lineas = data?.data || []
  const totales = data?.totales || {}
  const [busqueda, setBusqueda] = useState("")

  const filtradas = useMemo(() => {
    const q = busqueda.toLowerCase()
    if (!q) return lineas
    return lineas.filter(l =>
      String(l.descripcion || "").toLowerCase().includes(q) ||
      String(l.codigo || "").toLowerCase().includes(q),
    )
  }, [lineas, busqueda])

  if (lineas.length === 0) {
    return (
      <div style={{ padding: 60, textAlign: "center", color: "#64748b" }}>
        <i className="mdi mdi-package-variant-remove" style={{ fontSize: 48, color: "#cbd5e1" }} />
        <div className="mt-2">Sin líneas en esta factura.</div>
      </div>
    )
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
        <h6 style={{ margin: 0, color: "#0f172a", fontWeight: 600 }}>
          <i className="mdi mdi-format-list-bulleted me-2 text-primary" />
          Conceptos ({formatNumber(filtradas.length)} de {formatNumber(lineas.length)})
        </h6>
        <div style={{ position: "relative", maxWidth: 280 }}>
          <i className="mdi mdi-magnify" style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", color: "#94a3b8" }} />
          <input
            type="text"
            className="form-control form-control-sm"
            placeholder="Buscar concepto…"
            value={busqueda}
            onChange={e => setBusqueda(e.target.value)}
            style={{ paddingLeft: 32, minWidth: 240 }}
          />
        </div>
      </div>

      <div style={{ border: "1px solid #e2e8f0", borderRadius: 10, overflow: "hidden", background: "#fff" }}>
        <div style={{ maxHeight: 480, overflowY: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
            <thead>
              <tr>
                <th style={{ ...cellHead, width: 40, textAlign: "center" }}>#</th>
                <th style={cellHead}>Descripción</th>
                <th style={{ ...cellHead, textAlign: "right" }}>Cantidad</th>
                <th style={{ ...cellHead, textAlign: "right" }}>Precio</th>
                <th style={{ ...cellHead, textAlign: "right" }}>Base</th>
                <th style={{ ...cellHead, textAlign: "right" }}>Impuestos</th>
                <th style={{ ...cellHead, textAlign: "right" }}>Total</th>
              </tr>
            </thead>
            <tbody>
              {filtradas.map((l, i) => {
                const base = Number(l.baseimpuestos) || 0
                const imp = Number(l.impuestolinea) || 0
                return (
                  <tr key={i} style={{ borderBottom: "1px solid #f1f5f9" }}>
                    <td style={{ padding: "8px 12px", textAlign: "center", color: "#94a3b8", fontSize: 12 }}>{i + 1}</td>
                    <td style={{ padding: "8px 12px", color: "#0f172a", fontWeight: 500 }}>
                      {l.descripcion || "—"}
                      {l.codigo && (
                        <span style={{
                          marginLeft: 6, background: "#f1f5f9", color: "#475569",
                          padding: "1px 6px", borderRadius: 4, fontSize: 10, fontWeight: 600,
                          fontFamily: "ui-monospace, SFMono-Regular, monospace",
                        }}>{l.codigo}</span>
                      )}
                    </td>
                    <td style={{ padding: "8px 12px", textAlign: "right", color: "#475569" }}>
                      {formatNumber(l.cantidad, l.cantidad % 1 ? 2 : 0)}
                    </td>
                    <td style={{ padding: "8px 12px", textAlign: "right", color: "#475569" }}>
                      {formatCurrency(l.precio || l.precio_unitario)}
                    </td>
                    <td style={{ padding: "8px 12px", textAlign: "right", color: "#10b981", fontWeight: 600 }}>
                      {formatCurrency(base)}
                    </td>
                    <td style={{ padding: "8px 12px", textAlign: "right", color: "#f59e0b", fontWeight: 600 }}>
                      {formatCurrency(imp)}
                    </td>
                    <td style={{ padding: "8px 12px", textAlign: "right", color: "#0f172a", fontWeight: 700 }}>
                      {formatCurrency(base + imp)}
                    </td>
                  </tr>
                )
              })}
            </tbody>
            <tfoot>
              <tr style={{ background: "#f8fafc", borderTop: "2px solid #e2e8f0" }}>
                <td colSpan={4} style={{ padding: "10px 12px", fontWeight: 700, color: "#0f172a", textAlign: "right" }}>
                  Totales:
                </td>
                <td style={{ padding: "10px 12px", textAlign: "right", color: "#10b981", fontWeight: 700 }}>
                  {formatCurrency(totales.lineas_subtotal)}
                </td>
                <td style={{ padding: "10px 12px", textAlign: "right", color: "#f59e0b", fontWeight: 700 }}>
                  {formatCurrency(totales.lineas_impuestos)}
                </td>
                <td style={{ padding: "10px 12px", textAlign: "right", color: "#0f172a", fontWeight: 700, fontSize: 14 }}>
                  {formatCurrency(totales.lineas_total)}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  )
}

LineasTab.propTypes = { data: PropTypes.object }

export default LineasTab
